import { Heading, Spacer } from '@sparemin/blockhead';
import React from 'react';
import { useDispatch } from 'react-redux';
import ConfirmationModal from 'components/ConfirmationModal';
import { HourglassSand } from 'components/icons';
import CircularGradient from 'components/icons/circular-gradient/CircularGradient';
import Modal from 'components/Modal';
import useContextualUpgrade from 'hooks/useContextualUpgrade';
import { onUnlockThisFeature } from 'redux/modules/mixpanel';
import { replaceModal } from 'redux/modules/modal';
import { Dispatch } from 'redux/types';
import { createChainedFunction } from 'utils/functions';
import { block } from './utils';

export interface YouTubeMostReplayedUpsellModalContentsProps {}

const YouTubeMostReplayedUpsellModalContents: React.FC<YouTubeMostReplayedUpsellModalContentsProps> = () => {
  const dispatch = useDispatch<Dispatch>();

  const { onUpgrade } = useContextualUpgrade({
    openModal: replaceModal,
  });

  return (
    <>
      <ConfirmationModal.Body>
        <ConfirmationModal.Icon>
          <CircularGradient>
            <HourglassSand style={{ height: 40, width: 'auto' }} />
          </CircularGradient>
        </ConfirmationModal.Icon>

        <ConfirmationModal.Title>
          Get Clips from your Most Replayed Content
        </ConfirmationModal.Title>

        <Spacer
          orientation="vertical"
          align="center"
          justify="center"
          space="24px"
        >
          <Heading level={2} className={block('description')}>
            Link a YouTube video and automatically get a clip that features your
            most replayed content.
          </Heading>
        </Spacer>
      </ConfirmationModal.Body>

      <Modal.Footer>
        <Modal.FooterButtons fluid>
          <Modal.FooterButton
            theme="rainbow"
            onClick={createChainedFunction(onUpgrade, () =>
              dispatch(onUnlockThisFeature('MostReplayed')),
            )}
          >
            Unlock this feature
          </Modal.FooterButton>
        </Modal.FooterButtons>
      </Modal.Footer>
    </>
  );
};

export default YouTubeMostReplayedUpsellModalContents;
